const readTime = resource => {
    if (resource.read_time) {
        return resource.read_time;
    } else if (resource.acf && resource.acf.the_read_time) {
        return resource.acf.the_read_time;
    } else {
        return null;
    }
};

export default readTime;
